import { useLocation, useNavigate } from "react-router-dom";
import { BiExit } from "react-icons/bi";
import { RiMenuFoldLine, RiMenuUnfoldLine } from "react-icons/ri";
import formatName from "../helpers/formatName";
import { MenuItem } from "./MenuItem";
import { useDrawerContext } from "../contexts/drawer-context";

export const MenuItemsList = ({ items }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { isOpened, toggleIsOpened } = useDrawerContext();
  const usuario = localStorage.getItem("usuario_nome");
  const inicial = usuario ? formatName(usuario).charAt(0).toUpperCase() : "?";

  if (!items.length) return null;

  function handleSignOut() {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario_nome");
    localStorage.removeItem("permissao");
    localStorage.removeItem("id_usuario");
    navigate("/login", { replace: true });
  }

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      height: "calc(100vh - 48px)",
      background: "#0f1117",
      padding: "12px 10px",
      boxSizing: "border-box",
      overflow: "hidden",
      borderRadius: 12,
    }}>

      {/* Toggle */}
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: isOpened ? "space-between" : "center",
        paddingBottom: 14,
        marginBottom: 4,
        borderBottom: "1px solid rgba(255,255,255,0.06)",
      }}>
        {isOpened && (
          <span style={{
            color: "#f1f5f9",
            fontFamily: "Poppins, sans-serif",
            fontWeight: 700,
            fontSize: 15,
            letterSpacing: "-0.3px",
            paddingLeft: 4,
          }}>
            Menu
          </span>
        )}
        <button
          onClick={() => toggleIsOpened(!isOpened)}
          title={isOpened ? "Recolher" : "Expandir"}
          style={{
            background: "rgba(255,255,255,0.05)",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: 7,
            padding: "6px 7px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#64748b",
            transition: "background 0.15s, color 0.15s",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = "rgba(255,255,255,0.1)";
            e.currentTarget.style.color = "#e2e8f0";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = "rgba(255,255,255,0.05)";
            e.currentTarget.style.color = "#64748b";
          }}
        >
          {isOpened ? <RiMenuFoldLine size={16} /> : <RiMenuUnfoldLine size={16} />}
        </button>
      </div>

      {/* Avatar + nome */}
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "10px 4px 14px",
        marginBottom: 6,
        borderBottom: "1px solid rgba(255,255,255,0.06)",
        overflow: "hidden",
      }}>
        <div style={{
          width: 32, height: 32,
          borderRadius: "50%",
          background: "#1e293b",
          border: "1.5px solid rgba(255,255,255,0.12)",
          color: "#e2e8f0",
          fontWeight: 700,
          fontSize: 13,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          fontFamily: "Poppins, sans-serif",
        }}>
          {inicial}
        </div>
        {isOpened && (
          <div style={{ overflow: "hidden", minWidth: 0 }}>
            <div style={{
              color: "#e2e8f0",
              fontWeight: 600,
              fontSize: 12,
              fontFamily: "Poppins, sans-serif",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
              {usuario ? formatName(usuario) : "Usuário"}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 2 }}>
              <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#22c55e" }} />
              <span style={{ color: "#475569", fontSize: 10, fontFamily: "Poppins, sans-serif" }}>Online</span>
            </div>
          </div>
        )}
      </div>

      {/* Itens */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 2, overflowY: "auto" }}>
        {isOpened && (
          <span style={{
            fontSize: 10, fontWeight: 600, color: "#334155",
            fontFamily: "Poppins, sans-serif", letterSpacing: "0.07em",
            textTransform: "uppercase", padding: "4px 14px 6px",
          }}>
            Navegação
          </span>
        )}
        {items.map(({ literal, route, Icon }) => (
          <MenuItem
            Icon={Icon} literal={literal} route={route}
            key={route} selected={pathname === route} isOpened={isOpened}
          />
        ))}
      </div>

      {/* Sair — sempre no bottom */}
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: 10, marginTop: 8, paddingBottom: 8 }}>
        <button
          onClick={handleSignOut}
          title={!isOpened ? "Sair" : undefined}
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: isOpened ? "flex-start" : "center",
            gap: 10,
            padding: "9px 12px",
            background: "transparent",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            color: "#475569",
            fontFamily: "Poppins, sans-serif",
            transition: "background 0.15s, color 0.15s",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = "rgba(239,68,68,0.1)";
            e.currentTarget.style.color = "#f87171";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.color = "#475569";
          }}
        >
          <BiExit size={17} style={{ flexShrink: 0 }} />
          {isOpened && <span style={{ fontSize: 13, fontWeight: 500 }}>Sair da plataforma </span>}
        </button>
          {isOpened &&  <h6 style={{color:'#ffffff'}}>Versao do app: 1.0.7</h6>}
       
      </div>
    </div>
  );
};